import { CFlex, CMargin, DText, Flex } from '../../../../../styles/CommonStyles'
import Select from '../../../../common/dropdown/Select'
import Text from '../../../../../core/utils/Text'
import { UserDetailSettingBox } from '../../../../../styles/main/user'
import ActionButton from '../../../../common/buttons/ActionButton'
import { dueFiatCurrencies } from '../../../../../core/utils/dueFiats'
import { useEffect, useState } from 'react'
import { BiTrash } from 'react-icons/bi'
import { useUpdateAUser } from '../../../../../core/services/react-query/user'

const emptyAllowedCurrencies = { deposit: [], withdraw: [] }

const DueFiatSettings = ({ user, refetch }) => {

    const { mutate: updateUser, isLoading } = useUpdateAUser()

    // ---- state
    const [allowedFiatCurrency, setAllowedFiatCurrency] = useState(emptyAllowedCurrencies)
    const [selectedCoin, setSelectedCoin] = useState(null)

    useEffect(() => {
        setAllowedFiatCurrency({
            deposit: user?.allowedFiatCurrency?.deposit || [],
            withdraw: user?.allowedFiatCurrency?.withdraw || []
        })
    }, [user])

    // ---- select handler
    const onCurrencyChange = (idx) => {
        const coin = dueFiatCurrencies[idx]
        setSelectedCoin(coin)
    }

    const addCurrency = (type) => {
        if (!selectedCoin) return

        setAllowedFiatCurrency((current) => {
            if (current[type].includes(selectedCoin)) return current
            return { ...current, [type]: [...current[type], selectedCoin] }
        })
    }

    const removeCurrency = (type, currency) => {
        setAllowedFiatCurrency((current) => ({
            ...current,
            [type]: current[type].filter((item) => item !== currency)
        }))
    }

    const getUserPayload = () => ({
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        fatherName: user?.fatherName || '',
        birthDate: user?.birthDate || '',
        email: user?.email || '',
        mobile: user?.mobile || '',
        idNo: user?.idNo || '',
        phone: user?.phone || '',
        note: user?.note || '',
        mainFiatTransferMethod: user?.mainFiatTransferMethod || '',
        address: {
            country: user?.address?.country || 'ir',
            county: user?.address?.county || '',
            city: user?.address?.city || '',
            line: user?.address?.line || '',
            zip: user?.address?.zip || ''
        },
        affiliate: user?.affiliate || {},
        allowedFiatCurrency
    })

    const onSubmitClicked = () => {
        if (!user?._id) return

        updateUser({ id: user._id, data: getUserPayload() }, {
            onSuccess: () => refetch?.()
        })
    }

    const CurrencyList = ({ type }) => (
        <CFlex fw style={{ alignItems: 'stretch' }}>
            <CMargin margin='8px' />
            <DText main fontSize='s'><Text tid={type} /></DText>
            {allowedFiatCurrency[type].map((currency) => (
                <Flex
                    fw
                    justify='space-between'
                    key={`${type}-${currency}`}
                    style={{ padding: '8px 0', borderBottom: '1px solid #9993' }}
                >
                    <DText main fontSize='s'>{currency}</DText>
                    <button
                        type='button'
                        aria-label={`remove-${type}-${currency}`}
                        onClick={() => removeCurrency(type, currency)}
                        style={{ border: 0, background: 'transparent', color: '#d45', cursor: 'pointer', padding: 0 }}
                    >
                        <BiTrash size={18} />
                    </button>
                </Flex>
            ))}
        </CFlex>
    )

    return (
        <CFlex fw>
            <UserDetailSettingBox>

                <CMargin margin={'8px'} />
                <DText main fontSize={'s'}>
                    <Text tid={'currency'} />
                </DText>

                <CMargin margin={'4px'} />
                <Select
                    options={dueFiatCurrencies}
                    value={selectedCoin}
                    onValueChange={onCurrencyChange}
                    placeHolder={'select-currency'}
                    fontSize={'s'}
                    width={'100%'}
                    height={'42px'}
                    isDueCoin
                    isCountry
                />

                <Flex fw justify='space-between' style={{ gap: '8px', marginTop: '12px' }}>
                    <ActionButton active={!!selectedCoin} onClick={() => addCurrency('deposit')} loading={false} width='48%'>
                        <Text tid='deposit' />
                    </ActionButton>
                    <ActionButton active={!!selectedCoin} onClick={() => addCurrency('withdraw')} loading={false} width='48%'>
                        <Text tid='withdraw' />
                    </ActionButton>
                </Flex>

                <CurrencyList type='deposit' />
                <CurrencyList type='withdraw' />

                <CMargin margin={'12px'} />

                <ActionButton
                    active
                    onClick={onSubmitClicked}
                    loading={isLoading}
                >
                    <Text tid={'submit'} />
                </ActionButton>

            </UserDetailSettingBox>
        </CFlex>
    )
}

export default DueFiatSettings
